module.exports = __webpack_public_path__ + "static/mycuddy_mobile-450e6e1c030b0f39027feaed14968499.png";